/**
 * Utilidades de fecha compartidas para todo el módulo Support Engine
 */

/**
 * Formatea una fecha o timestamp a formato de hora (ej. 10:42 AM)
 * @param {string|number|Date} dateVal 
 * @returns {string}
 */
export const formatTime = dateVal => {
  if (!dateVal) return '';
  try {
    const date = new Date(dateVal);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
};

/**
 * Formatea una fecha a formato legible (ej. Hoy, 12 Oct 2023)
 * @param {string|number|Date} dateVal 
 * @returns {string}
 */
export const formatDateLabel = dateVal => {
  if (!dateVal) return '';
  try {
    const date = new Date(dateVal);
    if (isNaN(date.getTime())) return '';
    
    const today = new Date();
    if (date.toDateString() === today.toDateString()) {
      return 'Hoy';
    }
    return date.toLocaleDateString([], { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return '';
  }
};
